<p>
  hm-update-profile works!
</p>
